import { Icon } from "../../icons";
import type { SelectOption } from "./selectOption";

/** What leads an option's label: its avatar, else its color dot, else its icon (or nothing). */
export function OptionVisual({ option }: { option: SelectOption }): React.JSX.Element | null {
  if (option.avatar !== undefined) {
    return (
      <span className="nb-select-avatar" aria-hidden="true">
        {option.avatar}
      </span>
    );
  }
  if (option.color) return <span className="nb-select-dot" style={{ background: option.color }} aria-hidden="true" />;
  if (option.icon) return <Icon name={option.icon} className="nb-select-icon" aria-hidden="true" />;
  return null;
}
